/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import escape from 'cio/utils/escape';

interface HttpStatusLabelArgs {
  status: string;
}

export default class HttpStatusLabel extends Component<HttpStatusLabelArgs> {
  get escapedStatus() {
    return escape(this.args.status);
  }

  get statusClass() {
    let { status } = this.args;

    if (/^1\d\d/.test(status)) {
      return 'is-info';
    } else if (/^2\d\d/.test(status)) {
      return 'is-success';
    } else if (/^3\d\d/.test(status)) {
      return 'is-warning';
    }

    return 'is-danger';
  }
}
